<script setup>
import Modal from "@/components/modals/BaseModal.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  fields: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["close"]);

function handleClose() {
  emit("close");
}
</script>

<template>
  <Modal
    :show="props.show"
    :title="'Finish these to publish your listing'"
    :closeOnClickOutside="true"
    :buttonText="'Continue'"
    :modalSize="'normal'"
    :showCancelButton="false"
    @save="handleClose"
    @close="handleClose"
    titleIcon="<i class='uil uil-info-circle text-blue-500'></i>"
  >
    <template #description>
      Add missing info, then try publishing again.
    </template>
    <template #default>
      <div class="bg-echoes-background-black/80 rounded-lg p-3">
        <div
          v-for="field in props.fields"
          :key="field.label"
          class="flex gap-2"
        >
          <div class="w-2 h-2 bg-echoes-primary/80 rounded-full mt-2"></div>
          <div class="flex flex-col mb-2">
            <div class="text-sm font-medium">{{ field.label }}</div>
            <div class="text-white/60 text-xs">{{ field.description }}</div>
          </div>
        </div>
      </div>
      <div class="text-white/60 text-sm mt-2">
        If you'd like to save a draft use the toggle at the bottom of the
        listing editor.
      </div>
    </template>
  </Modal>
</template>

